interface SectionCardProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export const SectionCard = ({ title, children, className = "" }: SectionCardProps) => (
  <div className={`bg-surface rounded-xl border border-hairline overflow-hidden ${className}`}>
    {title && (
      <div className="px-4 pt-4 pb-1.5">
        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.12em] text-muted">
          {title}
        </p>
      </div>
    )}
    <div className="px-4 pb-4">{children}</div>
  </div>
);
